import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';
import { ConfigService } from '../services/config.service';


@Pipe({
  name: 'liveView'
})
export class LiveViewPipe implements PipeTransform {

  constructor(private appConfig: AppConfigService, private generalConfig: ConfigService) {}

  transform(value: any): any {
    let url  = '';
    let liveView_resolution = this.appConfig.getConfig().liveView_resolution;
    let liveView_fps = this.appConfig.getConfig().liveView_fps;
    let liveView_compression = this.appConfig.getConfig().liveView_compression;
    let liveView_camera = 1;
    

    // tslint:disable-next-line:triple-equals
    if ( this.appConfig.getConfig().liveView == false ) {
      url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/images/imgLiveviewDesactivado.png`;
    } else if (value === '10undefined' ) {
      url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/images/imgLiveview.png`;
    } else {
      const laneId = value.slice(-2);
      const second = value.slice(0, 2);
      let cameraId = '';
      let ocrServerId = '';
      const lanes = this.generalConfig.getLane(laneId);
      if (this.generalConfig.getLane(laneId)?.identification?.plates?.front != null){
          if (this.generalConfig.getLane(laneId)?.identification?.plates?.front[0]?.camId !== undefined){
            cameraId = ('0' + this.generalConfig.getLane(laneId)?.identification?.plates?.front[0]?.camId).slice(-2);
          }
          if (this.generalConfig.getLane(laneId)?.identification?.plates?.front[0]?.ocrServerId !== undefined){
            ocrServerId = ('0' + this.generalConfig.getLane(laneId)?.identification?.plates?.front[0]?.ocrServerId).slice(-2);
          }
      }
      const ocrServerIP = this.generalConfig.getOCRServerIP(Number(ocrServerId));
      const liveviewURL = this.generalConfig.getOCRServerCameraURL(Number(ocrServerId), Number(cameraId));
      // console.log ('ocr server ip', liveviewURL);
      const barraId = liveviewURL.indexOf('/', 9);
      // console.log('barraId: ' + barraId);
      const cameraIp = liveviewURL.substring(0, barraId);
      if (liveView_resolution == null){
        console.log('liveView_resolution not configured in frontend app initial config');
        liveView_resolution ='352x288';
      };
      if (liveView_fps == null){
        console.log('liveView_fps not configured in frontend app initial config');
        liveView_fps = 2; 
      }
      if (liveView_compression == null){
        console.log('liveView_compression not configured in frontend app initial config');
        liveView_compression = 10;
      }
      //url = cameraIp + `/axis-cgi/mjpg/video.cgi?resolution=${liveView_resolution}&fps=${liveView_fps}&compression=${liveView_compression}&camera=${liveView_camera}`;
      if(cameraIp === '' || cameraIp == null){
        url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/images/imgLiveview.png`;
      }else {
        url = cameraIp + `/axis-cgi/mjpg/video.cgi?fps=${liveView_fps}&compression=${liveView_compression}&camera=${liveView_camera}`;
      }
      
      //   console.log(url);
      console.log(`Initializing liviview L-${laneId}  livieview:  ${url}`);
      
    }


    return url;
  }

}



